import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=3738f920&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=ts&"
export * from "./Investment.vue?vue&type=script&lang=ts&"
import style0 from "./Investment.vue?vue&type=style&index=0&id=3738f920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738f920",
  null
  
)

export default component.exports